/* Lab401: Show variant option descriptions from metafields.
   The Liquid template builds a variant_id → description map,
   so this JS just reads the selected variant ID and shows the text. */
(function() {
  function init() {
    var dataEl = document.querySelector('[data-variant-descriptions]');
    var infoBox = document.querySelector('[data-variant-info-box]');
    if (!dataEl || !infoBox) return;

    var descriptions;
    try {
      descriptions = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variantSelect = document.querySelector('variant-selection select[name="id"]');
    if (!variantSelect) return;

    var lastVariantId = '';

    function update() {
      var id = variantSelect.value;
      if (id === lastVariantId) return;
      lastVariantId = id;

      var desc = descriptions[id];
      if (desc) {
        infoBox.textContent = desc;
        infoBox.style.display = 'block';
      } else {
        infoBox.style.display = 'none';
      }
    }

    update();

    /* Listen for native change events */
    variantSelect.addEventListener('change', update);

    /* Empire's variant-selection sets .value programmatically without
       firing change. Poll on radio button interactions instead. */
    var variantsBlock = document.querySelector('.product-block--variants');
    if (variantsBlock) {
      variantsBlock.addEventListener('change', function() {
        /* Small delay to let variant-selection update the select value */
        setTimeout(update, 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
